/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import EventsControllerDtoNoticeListNoticeData from './EventsControllerDtoNoticeListNoticeData';

/**
 * The EventsControllerDtoNoticeListResponse model module.
 * @module model/EventsControllerDtoNoticeListResponse
 * @version 1.0
 */
class EventsControllerDtoNoticeListResponse {
    /**
     * Constructs a new <code>EventsControllerDtoNoticeListResponse</code>.
     * @alias module:model/EventsControllerDtoNoticeListResponse
     */
    constructor() { 
        
        EventsControllerDtoNoticeListResponse.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>EventsControllerDtoNoticeListResponse</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/EventsControllerDtoNoticeListResponse} obj Optional instance to populate.
     * @return {module:model/EventsControllerDtoNoticeListResponse} The populated <code>EventsControllerDtoNoticeListResponse</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new EventsControllerDtoNoticeListResponse();

            if (data.hasOwnProperty('totalCount')) {
                obj['totalCount'] = ApiClient.convertToType(data['totalCount'], 'Number');
            }
            if (data.hasOwnProperty('list')) {
                obj['list'] = ApiClient.convertToType(data['list'], [EventsControllerDtoNoticeListNoticeData]);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>EventsControllerDtoNoticeListResponse</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>EventsControllerDtoNoticeListResponse</code>.
     */
    static validateJSON(data) {
        if (data['list']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['list'])) {
                throw new Error("Expected the field `list` to be an array in the JSON data but got " + data['list']);
            }
            // validate the optional field `list` (array)
            for (const item of data['list']) {
                EventsControllerDtoNoticeListNoticeData.validateJSON(item);
            };
        }

        return true;
    }


}



/**
 * @member {Number} totalCount
 */
EventsControllerDtoNoticeListResponse.prototype['totalCount'] = undefined;

/**
 * @member {Array.<module:model/EventsControllerDtoNoticeListNoticeData>} list
 */
EventsControllerDtoNoticeListResponse.prototype['list'] = undefined;






export default EventsControllerDtoNoticeListResponse;

